<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
import {
  getFileUrl,
} from 'api';
export default {
  data () {
    return {
      baseForm: {
        orgIdOptions: [],
        form: [
          {
            label: '司机账号',
            value: 'mobilePhone',
            type: 'show',
          },
          {
            label: '司机类型',
            value: 'applyCarUserTypeName',
            type: 'show',
          },
          {
            label: '司机头像',
            value: 'userImg',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
            disabled: true,
          },
        ],
      },
    };
  },
  methods: {

    async sub () {
      return {};
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return {
        mobilePhone: res.mobilePhone,
        applyCarUserTypeName: res.applyCarUserTypeName,
        userPrice: res.userPrice,
      };
    },
    async init (data = {}) {
      this.$refs.baseForm.setVal('mobilePhone', data.mobilePhone);
      this.$refs.baseForm.setVal('applyCarUserTypeName', data.applyCarUserTypeName);
      this.$refs.baseForm.setVal('userPrice', data.userPrice);
      if (data.userPrice) {
        const imgRes = await getFileUrl({
          flowIds: data.userPrice,
        });
        this.$refs.baseForm.setVal('userImg', [{
          url: imgRes.items[0].fullPath,
        }]);
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
